export enum Designation {
  Veterinarian = 'Veterinarian',
  Embryologist = 'Embryologist',
  Technician = 'Technician',
}
